import { THIRD_MOLAR_TOOTH_NUMBER } from '@/shared/config';

export const isThirdMolarTooth = (ISONumber: number) =>
  THIRD_MOLAR_TOOTH_NUMBER.includes(ISONumber);
